import React from "react";
import MainComponent from "../components/MainComponent";
import Footer from "../components/Footer";
import { Box } from "@mui/material";
import { styled } from "@mui/system";

const PageContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  minHeight: "100dvh", 
});

const ContentWrapper = styled(Box)({
  flex: 1, 
});

const EPSSCalculator = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <MainComponent />
      </ContentWrapper>
      <Footer />
    </PageContainer>
  );
};

export default EPSSCalculator;
